import { BarChart3, Check, Code2, Database, Rocket, Video } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";

const LINES = [
  { cmd: "cws enroll --track weekend-bootcamp", out: "SQL, Python & Power BI unlocked" },
  { cmd: "cws book --1-on-1 --with sankalp", out: "Reminder set for 24h before" },
  { cmd: "cws kids --program coding --pack 30", out: "Ready. Let's build something." },
];
const CHIPS = [
  { Icon: Database, t: "SQL", pos: "top-[6%] left-[4%]", d: "0s" },
  { Icon: Code2, t: "Python", pos: "top-[2%] right-[10%]", d: "1.2s" },
  { Icon: BarChart3, t: "Power BI", pos: "bottom-[4%] left-[10%]", d: "2.1s" },
  { Icon: Rocket, t: "Kids coding", pos: "bottom-[8%] right-[2%]", d: "0.6s" },
  { Icon: Video, t: "1-on-1s", pos: "top-[46%] -right-[2%]", d: "1.7s" },
];

function Terminal() {
  return (
    <div className="relative w-full max-w-md rounded-2xl border border-zinc-800 bg-[#0c0c0f]/95 shadow-[0_40px_100px_-40px_rgba(139,92,246,0.6)] backdrop-blur-xl">
      <div className="flex items-center gap-1.5 px-4 py-3 border-b border-zinc-800">
        <span className="w-2.5 h-2.5 rounded-full bg-red-500/80" />
        <span className="w-2.5 h-2.5 rounded-full bg-yellow-400/80" />
        <span className="w-2.5 h-2.5 rounded-full bg-emerald-500/80" />
        <span className="ml-3 text-[11px] font-adult-mono text-zinc-500">~/code-with-sankalp</span>
      </div>
      <div className="p-5 font-adult-mono text-[12.5px] leading-7">
        {LINES.map((l, i) => (
          <div key={l.cmd}>
            <div className="cws-line text-zinc-200" style={{ animationDelay: `${0.4 + i * 1.1}s` }}><span className="text-amber-400">$</span> {l.cmd}</div>
            <div className="cws-line flex items-center gap-2 text-emerald-400" style={{ animationDelay: `${0.9 + i * 1.1}s` }}><Check className="w-3.5 h-3.5" />{l.out}</div>
          </div>
        ))}
        <div className="cws-line" style={{ animationDelay: "3.8s" }}>
          <span className="text-amber-400">$</span> <span className="cws-caret inline-block w-2 h-4 align-middle bg-amber-400" />
        </div>
      </div>
    </div>
  );
}

export function AuthShowcase() {
  return (
    <div data-testid="auth-showcase" className="hidden md:flex relative flex-col justify-between p-12 lg:p-14 border-r border-zinc-900 grid-bg-adult overflow-hidden">
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="absolute -bottom-32 -left-24 w-[28rem] h-[28rem] rounded-full bg-violet-500/15 blur-3xl pointer-events-none" />
      <div className="absolute top-1/4 -right-24 w-[22rem] h-[22rem] rounded-full bg-amber-500/10 blur-3xl pointer-events-none" />
      <BrandLogo testid="auth-brand-logo" className="relative z-10" />
      <div className="relative z-10 flex-1 flex items-center justify-center my-10">
        <div className="relative w-full max-w-md py-10">
          <Terminal />
          {CHIPS.map(({ Icon, t, pos, d }) => (
            <span key={t} className={`hidden lg:inline-flex absolute ${pos} cws-float items-center gap-1.5 rounded-full border border-zinc-800 bg-zinc-950/90 px-3 py-1.5 text-xs text-zinc-300 shadow-lg`} style={{ animationDelay: d }}>
              <Icon className="w-3.5 h-3.5 text-amber-400" />{t}
            </span>
          ))}
        </div>
      </div>
      <div className="relative z-10 max-w-md">
        <h2 className="font-adult-heading text-4xl font-semibold tracking-tight leading-tight">Two worlds, <span className="font-adult-serif italic text-amber-400">one login</span>.</h2>
        <p className="mt-4 text-zinc-400">Join the Weekend Bootcamp, book a 1-on-1 with Sankalp, or book kids sessions, all from one dashboard.</p>
      </div>
    </div>
  );
}
